import React from 'react';
import ReactTooltip from 'react-tooltip';

export function Tooltip({
  name,
  borderColor = '#5b2f91',
  isCapture = false
}: {
  name: string;
  borderColor?: string;
  isCapture?: boolean;
}) {
  return (
    <ReactTooltip
      isCapture={isCapture}
      id={name}
      className='tooltip-custom'
      place='right'
      effect='solid'
      type='light'
      multiline
      border
      borderColor={borderColor}
    />
  );
}
